import { render, staticRenderFns } from "./BatchMainSelects.vue?vue&type=template&id=576bbdd6&"
import script from "./BatchMainSelects.vue?vue&type=script&lang=js&"
export * from "./BatchMainSelects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports